import { Component, ViewEncapsulation } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { LsqBasePaginationComponent } from '../base-pagination/lsq-base-pagination.component';

@Component({
    selector: 'lsq-simple-pagination',
    styleUrls: ['./lsq-simple-pagination.component.scss'],
    template: `
        <div class="simple-pagination">
            <div class="simple-pagination-arrows">
                <lsq-icon
                    (click)="handlePageChange(0)"
                    class="left arrow-button"
                    [ngClass]="{ disabled: currentPage === 1 }"
                    [color]="currentPage === 1 ? color.GrayLighter : color.GrayDarker"
                    [hoverColor]="currentPage === 1 ? color.GrayLighter : color.GrayDarkest"
                    [type]="icons.FirstPage"
                    [style.padding]="'2rem 2rem 2rem 0'"
                >
                </lsq-icon>
                <lsq-icon
                    (click)="incrementPage(paging.prev)"
                    class="left arrow-button"
                    [ngClass]="{ disabled: currentPage === 1 }"
                    [color]="currentPage === 1 ? color.GrayLighter : color.GrayDarker"
                    [hoverColor]="currentPage === 1 ? color.GrayLighter : color.GrayDarkest"
                    [type]="icons.ChevronLeft"
                    [style.padding]="'2rem 2rem 2rem 0'"
                >
                </lsq-icon>
            </div>
            <div class="simple-pagination-input">
                <lsq-page-input
                    id="current-page-number"
                    parentClass="simple-paging-input"
                    inputClass="simple-paging-input"
                    [min]="1"
                    [max]="pageCount"
                    [basicLabel]="true"
                    (pageUpdated)="handlePageChange($event)"
                    [ngModel]="currentPage"
                >
                </lsq-page-input>
                <span> / {{ pageCount }}</span>
            </div>
            <div class="simple-pagination-arrows">
                <lsq-icon
                    (click)="incrementPage(paging.next)"
                    class="right arrow-button"
                    [ngClass]="{ disabled: currentPage === pageCount }"
                    [color]="currentPage === pageCount ? color.GrayLighter : color.GrayDarker"
                    [hoverColor]="currentPage === pageCount ? color.GrayLighter : color.GrayDarkest"
                    [type]="icons.ChevronRight"
                    [style.padding]="'2rem 0 2rem 2rem'"
                >
                </lsq-icon>
                <lsq-icon
                    (click)="handlePageChange(pageCount)"
                    class="right arrow-button"
                    [ngClass]="{ disabled: currentPage === pageCount }"
                    [color]="currentPage === pageCount ? color.GrayLighter : color.GrayDarker"
                    [hoverColor]="currentPage === pageCount ? color.GrayLighter : color.GrayDarkest"
                    [type]="icons.LastPage"
                    [style.padding]="'2rem 0 2rem 2rem'"
                >
                </lsq-icon>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
})
export class LsqSimplePaginationComponent extends LsqBasePaginationComponent {
    public color = Color;
}
